export enum MentionChannel {
	Vehicle = '@',
	Union = '#',
}
